import React from "react";
import { FinancingPlan } from "tsi-common-react/src/models/financing";
import { getPageSetting } from "tsi-common-react/src/utils/settings";

interface IProps {
    plans: FinancingPlan[];
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple conditional render with no state, lifecycle methods, or complex logic.
export class BasketFinePrint extends React.Component<IProps, IState> {
    render() {
        if (this.props.plans.length <= 0) {
            return null;
        }
        return (
            <div
                id="basket-lines__fine-print"
                className="basket-lines__fine-print"
                dangerouslySetInnerHTML={{
                    __html: getPageSetting("basket-financing-fine-print"),
                }}
            ></div>
        );
    }
}
